import TransactionsApi from '@/services/shop/TransactionsApiV2'
import type { TransactionInterface } from '@/models/shop/TransactionV2.types'

export { TransactionInterface }

export class TransactionDTO implements TransactionInterface {
  cart_id = ''
  arena_id = 0
  restoring_transaction_id = ''
  restoring_reason = ''
  seller_user_id = 0
  buyer_user_id = 0
  created_at = ''
  updated_at = ''
  id = ''
  coins_given = 0
}

export default class Transaction extends TransactionDTO {
  static api = TransactionsApi

  constructor(DTO: TransactionDTO) {
    super()
    Object.assign(this, DTO)
  }
}
